if(!customElements.get('product-media-gallery')) {
  customElements.define(
    'product-media-gallery',
    class ProductMediaGallery extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;
      #sliderPrevEl = undefined;
      #sliderNextEl = undefined;
      #sliderPaginationEl = undefined;

      #thumbsEl = undefined;
      #thumbsInstance = undefined;
      #thumbsPrevEl = undefined;
      #thumbsNextEl = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.#thumbsEl = this.querySelector('[data-thumbs]');
        this.#sliderPrevEl = this.querySelector('[data-prev]');
        this.#sliderPrevEl = this.querySelector('[data-next]');
        this.#thumbsPrevEl = this.querySelector('[data-thumbs-prev]');
        this.#thumbsNextEl = this.querySelector('[data-thumbs-next]');
        this.mount();
      }

      mount() {
        if(!this.#sliderEl) {
          return console.error('[Slider] No slider element was found.')
        }

        this.#thumbsInstance = new Swiper(this.#thumbsEl, {
          slidesPerView: 3,
          spaceBetween: 8,
          breakpoints: {
            768: {
              slidesPerView: 4
            }
          },
          navigation: {
            prevEl: this.#thumbsPrevEl,
            nextEl: this.#thumbsNextEl,
          }
        });

        this.#sliderInstance = new Swiper(this.#sliderEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          thumbs: {
            swiper: this.#thumbsInstance
          }
        });

        this.enableZoom();
      }

      enableZoom() {
        const slides = this.#sliderEl.querySelectorAll('.slide[data-media-type="image"');
        if(!slides?.length > 0) return;

        function zoomIn(event) {
          let zoomEl = event.currentTarget.querySelector('img');
          let offsetX, offsetY;
        
          if (event.offsetX) {
            offsetX = event.offsetX;
          } else {
            offsetX = event.touches[0].pageX - zoomEl.getBoundingClientRect().left;
          }
        
          if (event.offsetY) {
            offsetY = event.offsetY;
          } else {
            offsetY = event.touches[0].pageY - zoomEl.getBoundingClientRect().top;
          }
        
          let x = (offsetX / zoomEl.offsetWidth) * 100;
          let y = (offsetY / zoomEl.offsetHeight) * 100;
        
          zoomEl.style.transformOrigin = `${x}% ${y}%`;
        }

        slides.forEach(slide => {
          slide.addEventListener('click', function(event) {
            event.preventDefault();
            const image = slide.querySelector('img');
        
            if (slide.classList.contains('zoom-in')) {
              image.style.transform = 'scale(1)';
              slide.classList.remove('zoom-in');
        
              slide.removeEventListener('mousemove', zoomIn);
            } else {
              image.style.transform = 'scale(2)';
              slide.classList.add('zoom-in');
              zoomIn(event);
        
              slide.addEventListener('mousemove', zoomIn);
            }
          });
        });
      }

      get slider() {
        return this.#sliderInstance;
      }
    }
  )
}